import React, {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

import * as constants from "constants/index.js";
import CardsHeader from "layouts/Headers/CardsHeader.js";


import TableCustom from "views/pages/components/TableCustom";

import {Card, CardBody, CardHeader, Col, Container, Row,} from "reactstrap";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import notify from '@utils/notify';

export default function Notifications() {
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const grs_token = Cookies.get("grs_token");

    const source = axios.CancelToken.source();

    const fetchData = async () => {
      try {
        const response = await axios({
          method: "GET",
          url: `${constants.API_URL}/settings/notifications`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        });
        console.log("response :: ", response.data);
        const data = response.data;

        setItems(data.data.items);

        setTimeout(() => {
          setLoading(false);
        }, 300);
      } catch (error) {
        setLoading(false);
        if (axios.isCancel(error)) {
          console.log("Request canceled :: ", error);
        } else {
          console.error("error :: ", error);
          notify.warning(error.response && error.response.data ? error.response.data.message : error.response ? error.response.statusText : "Error Occurred!");
        }
      }
    };

    fetchData();

    return () => {
      source.cancel();
    };
  }, []);

  const goList = () => {
    history.push({
      pathname: `/admin/settings/personalisation`,
    });
  };

  const showDetail = (row) => {
    history.push({
      pathname: `/admin/settings/personalisation/notifications/${row.id}/edit`,
    });
  }

  return (
    <>
      <CardsHeader
        name="Settings"
        parentName="Personalisation"
        currentName="Roles list"
      />
      <Container className="mt--5 admin-main-body" fluid>
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={7}>
                    <h1 className="mb-0">Notification Roles</h1>
                  </Col>
                  <Col xs={5} className="text-right">
                    <ButtonContainer
                      width={'300px'}
                      reverse
                      onClick={() => goList()}
                    >
                      Back to personalisation
                    </ButtonContainer>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom
                  loading={loading}
                  items={items}
                  columns={[
                    {
                      dataField: "name",
                      text: "Name",
                      sort: true,
                    },
                    {
                      dataField: "display_name",
                      text: "Display name",
                      sort: true,
                    },
                    {
                      dataField: "description",
                      text: "Description",
                      sort: true,
                    },
                    {
                      dataField: "",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                            <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'visibility'}
                                size={24}
                                onClick={() => {
                                  showDetail(row);
                                }}
                            />
                        );
                      },
                    },
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
